import { render, staticRenderFns } from "./BlockedBlock.vue?vue&type=template&id=3cf78b04"
import script from "./BlockedBlock.vue?vue&type=script&lang=js"
export * from "./BlockedBlock.vue?vue&type=script&lang=js"
import style0 from "./BlockedBlock.vue?vue&type=style&index=0&id=3cf78b04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports